import SourceFactory from '@components/sources/sourceFactory';
import { coerceRetlSubcategory, getOrigin } from '@stores/util';
import { SourceDefinitionCategory } from '@stores/types';
import { SourceConfig } from './types';

export const getSourceCategory = (
  sourceDefCategory: SourceDefinitionCategory,
  config: SourceConfig,
) =>
  // eslint-disable-next-line no-nested-ternary
  SourceFactory(sourceDefCategory).isWarehouse()
    ? {
        category: 'retl' as const,
        subcategory: coerceRetlSubcategory(getOrigin(config)),
      }
    : ['singer-protocol', 'cloud'].includes(sourceDefCategory ?? '')
    ? { category: 'extract' as const }
    : {
        category: 'event' as const,
      };
